import useFetch from 'core/redux/hooks/useFetch';
import fetchDifficulties from 'app/games/taboo/actions/fetchDifficulties';

export default function useFetchDifficulties() {
  return useFetch(fetchDifficulties);
}
